import axios from "axios";

import { eskalationsLevel, header, host, localCache } from "./globalVariables";
import { getCleanUsers, getKacheln } from "./networkFunctions";

export const api = axios.create({
   baseURL: host,
   withCredentials: true, // Gilt jetzt für alle Anfragen dieser Instanz
});
export async function httpPost(url, dataItem, setLoading, setErrorMessage) {
   const httpResponse = await api
      .post(url, dataItem, header)
      .then((respData) => {
         setLoading("success");
         setTimeout(() => {
            setLoading(false);
         }, 1100);
         return respData;
      })
      .catch((err) => {
         console.log(err);
         setErrorMessage({
            error: "onOffice",
            message: `Fehlerurl: ${url}<br/>` + JSON.stringify(err.response.data, null, 1),
         });
         setLoading("error");
      });

   return httpResponse;
}

export function getDateSpanArray(start, end) {
   const startDate = new Date(start);
   const endDate = new Date(end);
   const points = [startDate];

   // erster Tag des Monats nach dem Startdatum
   let current = new Date(startDate.getFullYear(), startDate.getMonth() + 1, 1);

   while (current < endDate) {
      points.push(new Date(current));
      current = new Date(current.getFullYear(), current.getMonth() + 1, 1);
   }

   points.push(endDate);

   const intervals = [];
   for (let i = 0; i < points.length - 1; i++) {
      intervals.push([points[i], points[i + 1]]);
   }

   return intervals;
}

export function parsePreisliste(text) {
   const zeilen = text.trim().split("\n");

   return zeilen.map((zeile) => {
      const [datumStr, preisStr] = zeile.split(":").map((s) => s.trim());

      // Datum parsen (Format: T.M.JJJJ)
      const [tag, monat, jahr] = datumStr.split(".").map(Number);
      const datum = new Date(jahr, monat - 1, tag);

      // Preis parsen: "2.105.000,00 €" -> 2105000.00
      const preis = parseFloat(
         preisStr
            ?.replace("€", "")
            ?.trim()
            ?.replace(/\./g, "") // Tausenderpunkte entfernen
            ?.replace(",", ".") ?? 0, // Komma zu Punkt für Dezimalstelle
      );

      return { datum, preis };
   });
}

export function calculateOODate(dateInput) {
   const jsDate = new Date(dateInput);
   const ooDate =
      jsDate.getFullYear() +
      "-" +
      (jsDate.getMonth() + 1).toString().padStart(2, "0") +
      "-" +
      jsDate.getDate().toString().padStart(2, "0");
   return ooDate;
}

export function calculateOODatetime(dateInput) {
   const jsDate = new Date(dateInput);
   const ooDate =
      jsDate.getFullYear() +
      "-" +
      (jsDate.getMonth() + 1).toString().padStart(2, "0") +
      "-" +
      jsDate.getDate().toString().padStart(2, "0") +
      " " +
      jsDate.toLocaleTimeString();
   return ooDate;
}

export function parseEMailPhone(data, type) {
   const allKeys = Object.keys(data);
   const basicKeys = allKeys.filter((element) => element.includes(type + "_"));
   const privateKeys = allKeys.filter((element) => element.includes(type + "private_"));
   const businessKeys = allKeys.filter((element) => element.includes(type + "business_"));

   return {
      all: [...basicKeys, ...businessKeys, ...privateKeys].map((keyItem) => data[keyItem]),
      basic: basicKeys.map((keyItem) => data[keyItem]),
      business: businessKeys.map((keyItem) => data[keyItem]),
      private: privateKeys.map((keyItem) => data[keyItem]),
   };
}

export function sortArrayOfObjects(unsortedArray, keyName, direction) {
   let clonedUnsorted = structuredClone(unsortedArray);

   const aufsteigend = direction > 0;
   let sortedArray = clonedUnsorted.sort((a, b) => {
      let valA = a[keyName];
      let valB = b[keyName];

      // Falls die Werte numerisch sind (auch als String), als Zahl vergleichen
      if (!isNaN(valA) && !isNaN(valB) && valA !== "" && valB !== "") {
         valA = Number(valA);
         valB = Number(valB);
      }

      if (valA > valB) return aufsteigend ? 1 : -1;
      if (valA < valB) return aufsteigend ? -1 : 1;
      return 0;
   });

   return sortedArray;
}

export function handlephoneandemail(item) {
   if (item.oldvalue) {
      if (item.value) {
         return {
            action: "modify",
            oldvalue: item.oldvalue,
            newvalue: item.value ? item.value : "-",
         };
      } else {
         return { action: "delete", oldvalue: item.oldvalue };
      }
   } else {
      if (item.value) {
         return { action: "add", newvalue: item.value };
      } else {
         return false;
      }
   }
}

export const teamsMessageFunctions = {
   bewertungsBestellung: function ({
      basicdata = {},
      objektBezeichung = {},
      estateId = {},
      kachelId = {},
      fieldconfiguration = {},
      users = {},
      ownerData = {},
      ordnerName = {},
   }) {
      console.log(basicdata);
      return `
<div>
    <div><a style="font-size: 16px; font-weight: bold;" href="https://programme.baur-immobilien.de/bewertungsmappe?estateid=${estateId}">${basicdata[objektBezeichung]}</a> </div>
    <div>${basicdata.bb_hinweis}</div>
       <table border="0" cellspacing="0" cellpadding="0" style="background-color: #0000;" >
            <tr>
                <td>
                Anzahl
                </td>
                <td>
                ${basicdata.bb_zahl}
                </td>
            </tr>
            <tr >
                <td>
                Süßigkeit
                </td>
                <td>
                ${basicdata.bb_schoko}
                </td>
            </tr>
            <tr>
                <td>
                Format
                </td>
                <td>
                ${basicdata.bb_format}
                </td>
            </tr>
            <tr>
                <td>
                Deadline
                </td>
                <td>
                ${new Date(basicdata.bb_dat).toLocaleString()}
                </td>
            </tr>
        </table>
</div>
`;
   },
   vamNachricht: function ({
      basicdata = {},
      objektBezeichung = {},
      estateId = {},
      kachelId = {},
      fieldconfiguration = {},
      users = {},
      ownerData = {},
      ordnerName = {},
   }) {
      console.log(basicdata);
      return `
<div>
<h1>Makler-Vorankündigungskachel ist fertig</h1><br/>
<p>Hinweis: <strong>${basicdata.vam_hinw}</strong> </p> <br/>
<a style="font-size: 16px; font-weight: bold;" href="https://programme.baur-immobilien.de/datenblatt?estateid=${estateId}&stufe=vorankuendigung">${basicdata[objektBezeichung]}</a> 
</div>
`;
   },
   auftragNachricht: function ({
      basicdata = {},
      objektBezeichung = {},
      estateId = {},
      kachelId = {},
      fieldconfiguration = {},
      users = {},
      ownerData = {},
      ordnerName = {},
   }) {
      console.log(basicdata);
      return `
<div>
<strong>${basicdata[objektBezeichung]}</strong>
<ul>
<li><strong>Eigentümer</strong>: ${ownerData.KdNr} ${ownerData.Vorname} ${ownerData.Name} </li>
<li><strong>Leadart</strong>: ${ownerData.ind_3064_Feld_adressen86 && fieldconfiguration && fieldconfiguration.address ? fieldconfiguration.address.ind_3064_Feld_adressen86.permittedvalues[ownerData.ind_3064_Feld_adressen86] : ""} </li>
<li><strong>Standort</strong>: ${basicdata.strasse} ${basicdata.hausnummer} ${basicdata.plz} ${basicdata.ort} </li>
<li><strong>Objektart</strong>: ${fieldconfiguration && fieldconfiguration.estate && basicdata.objektart ? fieldconfiguration.estate.objektart.permittedvalues[basicdata.objektart] : ""} </li>
<li><strong>Preiserwartung Kunde</strong>:${basicdata.bmkundenpreiserwartung}€ </li>
<li><strong>Preisspanne</strong>: ${basicdata.bb_minw}€ - ${basicdata.bb_maxw}€ </li>
<li><strong>Kaufpreis</strong>: ${basicdata.kaufpreis}€ </li>
<li><strong>Nutzung</strong>: ${basicdata.dbha_nutzung}</li>
<li><strong>Zustand</strong>: ${fieldconfiguration && fieldconfiguration.estate && basicdata.zustand ? fieldconfiguration.estate.zustand.permittedvalues[basicdata.zustand] : ""}</li>
<li><strong>Sonstige Unterlagen</strong>: ${basicdata.ug_dok}</li>
</ul>
<p>Besonderheiten:</p>
<p>${basicdata.unp_bes}</p>
<br/> <br/>
<strong>Highlights</strong>
<ol>
<li> ${basicdata.db_high1} </li>
<li> ${basicdata.db_high2} </li>
<li> ${basicdata.db_high3} </li>
</ol><br/>
<strong>Lowlights</strong>
<ol>
<li> ${basicdata.db_low1} </li>
<li> ${basicdata.db_low2} </li>
<li> ${basicdata.db_low3} </li>
</ol>
<strong>Sonstige</strong>
${basicdata.db_sonsHighlight}

<br/> <br/>
<a style="font-size: 16px; font-weight: bold;" href="https://programme.baur-immobilien.de/datenblatt?estateid=${estateId}&stufe=vollmacht">CRM</a> <a style="font-size: 16px; font-weight: bold;" href="https://baurimmo.sharepoint.com/sites/BaurImmobiliene.K/Immobilien/${basicdata[ordnerName]}">Sharepoint-Ordner</a> <a style="font-size: 16px; font-weight: bold;" href="https://programme.baur-immobilien.de/nutzerauswertung?lat=${basicdata.breitengrad}&lon=${basicdata.laengengrad}">Karte</a> 
</div>
`;
   },
   expoTextNachricht: function ({
      basicdata = {},
      objektBezeichung = {},
      estateId = {},
      kachelId = {},
      fieldconfiguration = {},
      users = {},
      ownerData = {},
   }) {
      console.log(basicdata);
      return `
<div>
Exposétext wurde hochgeladen:  <a style="font-size: 16px; font-weight: bold;" href="https://programme.baur-immobilien.de/datenblatt?estateid=${estateId}&stufe=expotext&kachel=expo_text">${basicdata[objektBezeichung]}</a> 
</div>
`;
   },

   expoNachtragNachricht: function ({
      basicdata = {},
      objektBezeichung = {},
      estateId = {},
      kachelId = {},
      fieldconfiguration = {},
      users = {},
      ownerData = {},
   }) {
      console.log(basicdata);
      return `
<div>
${basicdata["heading_" + kachelId] ? basicdata["heading_" + kachelId] : "Nachtrag"}: <a style="font-size: 16px; font-weight: bold;" href="https://programme.baur-immobilien.de/datenblatt?estateid=${estateId}&stufe=exponachtrag&kachel=${kachelId}">${basicdata[objektBezeichung]}</a> 
</div>
`;
   },
   wflKoordinationNachricht: function ({
      basicdata = {},
      objektBezeichung = {},
      estateId = {},
      kachelId = {},
      fieldconfiguration = {},
      users = {},
      ownerData = {},
   }) {
      console.log(basicdata);
      return `
<div>
Bitte neue Wohnfläche berechnen: <a style="font-size: 16px; font-weight: bold;" href="https://programme.baur-immobilien.de/datenblatt?estateid=${estateId}">${basicdata[objektBezeichung]}</a><br/>
Bemerkung:<br/>
${basicdata.wfk_txt}</div>
`;
   },
   wflErgebnisNachricht: function ({
      basicdata = {},
      objektBezeichung = {},
      estateId = {},
      kachelId = {},
      fieldconfiguration = {},
      users = {},
      ownerData = {},
   }) {
      console.log(basicdata);
      return `
<div>
Wohnflächenberechnung ist fertig <a style="font-size: 16px; font-weight: bold;" href="https://programme.baur-immobilien.de/datenblatt?estateid=${estateId}">${basicdata[objektBezeichung]}</a><br/>
<br/>
</div>
`;
   },

   wflFotoNachricht: function ({
      basicdata = {},
      objektBezeichung = {},
      estateId = {},
      kachelId = {},
      fieldconfiguration = {},
      users = {},
      ownerData = {},
   }) {
      console.log(basicdata);
      return `
<div>
Bitte neue Wohnfläche berechnen: <a style="font-size: 16px; font-weight: bold;" href="https://programme.baur-immobilien.de/datenblatt?estateid=${estateId}">${basicdata[objektBezeichung]}</a><br/>
Bemerkung:<br/>
${basicdata.wfk_txt}</div>
`;
   },
   fotoKoord: function ({
      basicdata = {},
      objektBezeichung = {},
      estateId = {},
      kachelId = {},
      fieldconfiguration = {},
      users = {},
      ownerData = {},
   }) {
      console.log(basicdata);
      return `
<div>
<strong>Fototermin vereinbaren: </strong>
<a style="font-size: 16px; font-weight: bold;" href="https://programme.baur-immobilien.de/datenblatt?estateid=${estateId}">${basicdata[objektBezeichung]}</a> 
<ul>
<li><strong>Objektnummer</strong>: ${basicdata.objektnr_extern} </li>
<li><strong>Zustand</strong>: ${basicdata.ind_3374_Feld_ObjIndividualCategoryFields314} </li>
<li><strong>Makler</strong>: ${users[basicdata.benutzer] && users[basicdata.benutzer].Name} </li>
<li><strong>Kontaktperson</strong>: ${basicdata.unp_knkt} ${basicdata.unp_knktname} ${basicdata.unp_knktnr} </li>
<li><strong>Fototermin ab</strong>: ${basicdata.ind_3402_Feld_ObjIndividualCategoryFields321} </li>  
</ul>
${basicdata.unp_bes} 
</div>
`;
   },

   fotoFertig: function ({
      basicdata = {},
      objektBezeichung = {},
      estateId = {},
      kachelId = {},
      fieldconfiguration = {},
      users = {},
      ownerData = {},
   }) {
      console.log(basicdata);
      return `
<div>
<strong>Fotos sind fertig: </strong>
<a style="font-size: 16px; font-weight: bold;" href="https://programme.baur-immobilien.de/datenblatt?estateid=${estateId}">${basicdata[objektBezeichung]}</a> 
<br/>
${basicdata.ft_gfkBem} 
<br/>
<a style="font-size: 16px; font-weight: bold;" href="${basicdata.ft_dnld}">Foto-Downloadlink</a>
</div>
`;
   },
   adminTerminNachricht: function ({ notiz = "", datum = "" }) {
      return `
<div>
Ich habe einen Termin am <strong>${datum.toLocaleString()} </strong> gebucht.
<br/>
Es geht um:
<br/>
${notiz}
</div>
`;
   },
};

export function teamsGLTerminNachricht(notiz, datum) {
   return `<div>
       Ich habe einen Termin am <strong>${datum.toLocaleString()} </strong> gebucht.
    </div>`;
}

export function getKachelObject(newestatekacheln) {
   return Object.values(newestatekacheln)
      .reduce((oldArr, item) => [...oldArr, item.kachel], [])
      .flat()
      .reduce(
         (oldObj, item) => ({
            ...oldObj,
            [item.kachelId]: {
               projektId: item.projektId,
               heading: item.heading,
               kachelId: item.kachelId,
            },
         }),
         {},
      );
}

export function getAllFieldnames(estatekacheln) {
   const flatarray = Object.values(estatekacheln)
      .reduce((arr, item) => [...arr, ...item.kachel], []) //ergibt alle Kacheln aus allen Projektstufen als Array
      .reduce((arr2, item2) => [...arr2, item2.layout], []) //alle Layouts jeder Kachel
      .flat()
      .flat();

   const headingarray = Object.values(estatekacheln)
      .reduce((arr, item) => [...arr, ...item.kachel], [])
      .map((item) => ({ name: "heading_" + item.kachelId })); //ergibt alle Kacheln aus allen Projektstufen als Array
   return [...flatarray, ...headingarray];
}

export function checkdependency(dependencyarray, alldata) {
   //Äußere Klammer ist oder verknüpft, innere und
   //const test=[[["key0","val0"]["key1", "val1"]][["key3", "val3"]]] //(key0 gleich val0 und key1 gleich val1)oder (key3 gleich val3)
   //Äußere Klammer ist ODER verknüpft, innere UND

   let oder_result = dependencyarray.length ? false : true;

   !oder_result &&
      dependencyarray.forEach((oder_array, index) => {
         let und_result = true;
         oder_array.forEach((und_array, index2) => {
            if (alldata[und_array[0]] != und_array[1]) {
               und_result = false;
            }
         });
         if (und_result) {
            oder_result = true;
         }
      });
   return oder_result;
}

export function updateProjektStatus(eskalationsstatus, kacheln) {
   /* Guckt, ob die Pflichtkacheln abgeschlossen sind */
   let neweskstatus = structuredClone(eskalationsstatus);

   Object.keys(kacheln).forEach((item, index) => {
      let maxKachelStufe = 0;
      let minKachelStufe = 4;
      let hasAktiveKachel = false;

      kacheln[item].kachel.some((item2, index2) => {
         if (eskalationsstatus["kachel_status_" + item2.kachelId] < 9) {
            hasAktiveKachel = true;
            if (
               neweskstatus["kachel_eskalation_" + item2.kachelId] &&
               new Date(neweskstatus["kachel_eskalation_" + item2.kachelId]) < new Date() &&
               neweskstatus["kachel_status_" + item2.kachelId] < eskalationsLevel
            ) {
               maxKachelStufe = -1;
               minKachelStufe = -1;
               return true;
            } else if (neweskstatus["kachel_status_" + item2.kachelId] < 4) {
               maxKachelStufe = Math.max(maxKachelStufe, neweskstatus["kachel_status_" + item2.kachelId]);
            }
            minKachelStufe = Math.min(minKachelStufe, neweskstatus["kachel_status_" + item2.kachelId]);
         }
      });
      if (hasAktiveKachel) {
         neweskstatus["projekt_status_" + item] = minKachelStufe < 4 ? maxKachelStufe : minKachelStufe;
      }
   });

   return neweskstatus;
}

export function oldUpdateProjektStatus(eskalationsstatus, aktiveKacheln) {
   /* Guckt, ob die Pflichtkacheln abgeschlossen sind */
   let neweskstatus = structuredClone(eskalationsstatus);

   Object.keys(aktiveKacheln).forEach((item, index) => {
      let kachelprogress = 0;
      let projektstufeBegonnen = 0;
      let maxkachelprogress = 0;
      let progresseskaliert = false;

      aktiveKacheln[item].kachel.forEach((item2, index2) => {
         if (neweskstatus["kachel_status_" + item2.kachelId] > 0) {
            projektstufeBegonnen = 1;
         }
         if (
            neweskstatus["kachel_eskalation_" + item2.kachelId] &&
            new Date(neweskstatus["kachel_eskalation_" + item2.kachelId]) < new Date() &&
            neweskstatus["kachel_status_" + item2.kachelId] < eskalationsLevel
         ) {
            progresseskaliert = true;
         }

         maxkachelprogress++;
         kachelprogress += neweskstatus["kachel_status_" + item2.kachelId] === 4 ? 1 : 0; //&& item2.pflichtKachel? 1: 0;
      });

      neweskstatus["projekt_eskaliert_" + item] = progresseskaliert;
      neweskstatus["projekt_status_" + item] = progresseskaliert
         ? -1
         : kachelprogress === maxkachelprogress
           ? 4
           : projektstufeBegonnen;
   });

   return neweskstatus;
}

export async function getFieldConfiguration(module, fieldList) {
   let newfieldConfiguration;

   /* Für Namensauflösung der oO-Singleselect-Werte */
   newfieldConfiguration = await api
      .post(
         "/api/getFieldConfiguration",
         {
            fieldList: fieldList,
            modules: module,
         },
         header,
      )
      .then((data) => {
         return data.data;
      })
      .catch((err) => {
         console.log(JSON.stringify(err.response.data, null, 1));
         localStorage.removeItem(localCache.build);
         return { error: JSON.stringify(err.response.data, null, 1) };
      });

   return newfieldConfiguration;
}

export async function getStaticData() {
   let staticDataExp = localStorage.getItem(localCache.expDate);
   const buildNumber = localStorage.getItem(localCache.build);

   let version = await api.get("/api/getBuildnumber", header).then((data) => {
      return data.data;
   });

   if (version && buildNumber != version) {
      localStorage.setItem(localCache.build, version);
      staticDataExp = false;
      console.log("new build");
   }

   let newestatekacheln, cleanUserData, newfieldConfiguration;

   if (!staticDataExp || new Date(JSON.parse(staticDataExp)) < new Date()) {
      console.log("Daten abgelaufen");
      let expirationDate = new Date();
      expirationDate.setDate(expirationDate.getDate() + 1);
      localStorage.setItem(localCache.expDate, JSON.stringify(expirationDate.toISOString()));

      newestatekacheln = await getKacheln();
      localStorage.setItem(localCache.estatekacheln, JSON.stringify(newestatekacheln));

      /* Liste aller Nutzer von oO laden */

      cleanUserData = await getCleanUsers();
      localStorage.setItem(localCache.userData, JSON.stringify(cleanUserData));

      let fieldConfigResponse = await api
         .post(
            "/api/getFieldConfiguration",
            {
               modules: ["estate", "address", "calendar", "task"],
            },
            header,
         )
         .then((data) => {
            return data.data.reduce((oldObj, item) => ({ ...oldObj, [item.id]: item.elements }), {});
         })
         .catch((err) => {
            console.log(JSON.stringify(err.response.data, null, 1));
            localStorage.removeItem(localCache.build);
            return { error: JSON.stringify(err.response.data, null, 1) };
         });

      localStorage.setItem(localCache.fieldConfig, JSON.stringify(fieldConfigResponse));
      newfieldConfiguration = fieldConfigResponse;
   } else {
      newestatekacheln = JSON.parse(localStorage.getItem(localCache.estatekacheln));
      cleanUserData = JSON.parse(localStorage.getItem(localCache.userData));
      newfieldConfiguration = JSON.parse(localStorage.getItem(localCache.fieldConfig));
   }

   return [newestatekacheln, cleanUserData, newfieldConfiguration];
}

export function parseOODate(startDate, endDate) {
   let dateLimit = [];
   const start = new Date(startDate);

   dateLimit.push(
      start.getFullYear() +
         "-" +
         (start.getMonth() + 1).toString().padStart(2, "0") +
         "-" +
         start.getDate().toString().padStart(2, "0"),
   );

   if (endDate) {
      const end = new Date(endDate);

      dateLimit.push(
         end.getFullYear() +
            "-" +
            (end.getMonth() + 1).toString().padStart(2, "0") +
            "-" +
            end.getDate().toString().padStart(2, "0"),
      );
   }
   return dateLimit;
}

export function parseOODateTime(startDateTime) {
   const start = new Date(startDateTime);

   return (
      start.getFullYear() +
      "-" +
      (start.getMonth() + 1).toString().padStart(2, "0") +
      "-" +
      start.getDate().toString().padStart(2, "0") +
      " " +
      start.getHours().toString().padStart(2, "0") +
      ":" +
      start.getMinutes().toString().padStart(2, "0") +
      ":" +
      start.getSeconds().toString().padStart(2, "0")
   );
}

export function formatCurrency(price) {
   return new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(price);
}

export function parseOOPercent(percent) {
   return parseFloat(percent.slice(0, -2).replace(",", ".")) / 100;
}

export function calculateStufenStatus() {
   let currentPS = {};
   Object.keys(datenblattkacheln).forEach((stufen_key) => {
      let kachelstatusSumme = 0;
      currentPS[stufen_key] = 0;

      let maxKachelStufe = 0;
      let minKachelStufe = 4;
      Object.values(datenblattkacheln[stufen_key].kachel).some((kachel) => {
         if (
            eskstatus["kachel_status_" + kachel.kachelId] < eskalationsLevel &&
            eskstatus["kachel_eskalation_" + kachel.kachelId] &&
            new Date(eskstatus["kachel_eskalation_" + kachel.kachelId]) < new Date()
         ) {
            maxKachelStufe = 9;
            minKachelStufe = 0;
            return true;
         } else if (
            eskstatus["kachel_status_" + kachel.kachelId] <
            4 /* &&eskstatus["kachel_status_" + kachel.kachelId]>=eskalationsLevel */
         ) {
            maxKachelStufe = Math.max(maxKachelStufe, eskstatus["kachel_status_" + kachel.kachelId]);
         }

         minKachelStufe = Math.min(minKachelStufe, eskstatus["kachel_status_" + kachel.kachelId]);
      });
      currentPS[stufen_key] = minKachelStufe < 4 ? maxKachelStufe : minKachelStufe;
   });
   console.log(currentPS);

   setProjektstufenStatus(currentPS);
}

export function filterProjektStufenStatus(newKachelObject, newProjektstufenStatus, newKachelStatus, eskalationsDatum) {
   if (eskalationsDatum) {
      Object.keys(eskalationsDatum).forEach((dat_item) => {
         if (new Date() < new Date(eskalationsDatum[dat_item])) {
            delete eskalationsDatum[dat_item];
         } else {
            if (newKachelStatus[dat_item] < eskalationsLevel) {
               if (newKachelObject[dat_item] && newKachelObject[dat_item].projektId)
                  newProjektstufenStatus[newKachelObject[dat_item].projektId] = -1;
            }
         }
      });
   }
}

export function isValidDate(val) {
   return val && !isNaN(new Date(val).getTime()) && val != "0000-00-00";
}

export function evaluateRule(item, rule) {
   // Falls es eine Untergruppe ist (OR / AND)
   if (!rule) {
      return true;
   }

   if (rule.logic) {
      if (rule.logic === "and") {
         return rule.rules.every((subRule) => evaluateRule(item, subRule));
      }
      if (rule.logic === "or") {
         return rule.rules.some((subRule) => evaluateRule(item, subRule));
      }
   }

   // Die eigentliche Feld-Prüfung (Logik-Zentrum)
   // const value = item[rule.field];
   const value = getValueByPath(item, rule.field);

   switch (rule.op) {
      case "===":
         return value === rule.value;
      case "!==":
         return value !== rule.value;
      case "<=":
         return value <= rule.value;
      case ">=":
         return value >= rule.value;
      case "<":
         return value < rule.value;
      case ">":
         return value > rule.value;
      case "hasValue":
         return value !== undefined && value !== null && value !== "";
      case "valid":
         return value !== undefined && value !== null;
      case "afterDays":
         return Date.now() + rule.value * 24 * 60 * 60 * 1000 > new Date(value).getTime();
      case "beforeDays":
         return Date.now() + rule.value * 24 * 60 * 60 * 1000 < new Date(value).getTime();

      case "has_image":
         return item.images && item.images.length > 0;
      default:
         return true;
   }
}

export function getValueByPath(obj, path) {
   if (!obj || typeof obj !== "object") {
      return undefined;
   } else {
      return path.split(".").reduce((acc, part) => {
         if (acc && acc[part] !== undefined) {
            return acc[part];
         } else return undefined;
      }, obj);
   }
}

export function calcProvision(data, config) {
   let innenProv,
      aussenProv = 0;
   if (config.company === "baur") {
      let kaufpreis = parseFloat(data?.[config.estate.verkauftFur]) || parseFloat(data.kaufpreis);
      innenProv =
         (parseFloat(data[config.estate.provPausAK]) > 0
            ? parseFloat(data[config.estate.provPausAK])
            : (parseFloat(data.innen_courtage.replace("€", "").replaceAll(" ", "").replace(",", ".")) * kaufpreis) /
              100) / 1.19;
      aussenProv =
         (parseFloat(data[config.estate.provPausVK]) > 0
            ? parseFloat(data[config.estate.provPausVK])
            : (parseFloat(data.aussen_courtage.replace("€", "").replaceAll(" ", "").replace(",", ".")) * kaufpreis) /
              100) / 1.19;
   } else if (config.company === "bender") {
      if (data[config.estate.gesamtProvision] && parseFloat(data[config.estate.gesamtProvision]) > 0) {
         innenProv = parseFloat(data[config.estate.gesamtProvision]);
      } else {
         innenProv = (parseFloat(data.kaufpreis) * parseFloat(data[config.estate.nettoKProvision] ?? 3)) / 100;
         aussenProv = (parseFloat(data.kaufpreis) * parseFloat(data[config.estate.nettoVKProvision] ?? 3)) / 100;
      }
   }

   return (isNaN(innenProv) ? 0 : innenProv) + (isNaN(aussenProv) ? 0 : aussenProv);
}

export function calculateKachelStatus(item, kachelId) {
   let statusLevel = item.kachelstatus[kachelId];
   if (
      typeof item.kachelstatus[kachelId] !== "undefined" &&
      item.kachelstatus[kachelId] < eskalationsLevel &&
      item.eskalationen[kachelId] &&
      new Date(item.eskalationsDaten[kachelId]) < new Date()
   ) {
      statusLevel = -1;
   }

   return statusLevel;
}

export function robustJsonParse(content) {
   let parsedText;
   try {
      let clean = content
         .replace(/^```(?:json)?\s*/, "")
         .replace(/```\s*$/, "")
         .trim();

      parsedText = JSON.parse(clean);
   } catch (error) {}
   return parsedText;
}

export function parseArray(content) {
   let parsedText;
   try {
      let clean = content
         .replace(/^```(?:json)?\s*/, "")
         .replace(/```\s*$/, "")
         .trim();

      parsedText = JSON.parse(clean).map((arrayItem) => arrayItem);
   } catch (error) {
      parsedText = [content];
   }

   return parsedText;
}

export function cleanAIAnswer(content) {
   let cleanedContent;
   try {
      cleanedContent = content
         .replace(/^```(?:json)?\s*/, "")
         .replace(/```\s*$/, "")
         .replace("Nutze diese Variante für alle weiteren Anfragen: ", "")
         .replaceAll("*", "")
         .trim();
   } catch (error) {
      cleanedContent = content ?? "";
   }

   return cleanedContent;
}

function getBestGermanVoice() {
   const voices = window.speechSynthesis.getVoices();
   return (
      voices.find((v) => v.lang.startsWith("de") && v.name.includes("Google")) ||
      voices.find((v) => v.lang.startsWith("de") && !v.localService) ||
      voices.find((v) => v.lang.startsWith("de"))
   );
}

export function speakGerman(text, setPlayAudio, options = {}) {
   if (!("speechSynthesis" in window)) {
      console.warn("Speech synthesis not supported in this browser");
      return;
   }

   // Cancel any ongoing speech first
   window.speechSynthesis.cancel();

   const utterance = new SpeechSynthesisUtterance(text);
   utterance.lang = "de-DE";
   utterance.rate = options.rate ?? 1;
   utterance.pitch = options.pitch ?? 1;
   utterance.volume = options.volume ?? 1;

   // Try to pick a proper German voice if available
   const voices = window.speechSynthesis.getVoices();
   /* const germanVoice = voices.find((v) => v.lang.startsWith("de"));
   if (germanVoice) */
   console.log(getBestGermanVoice());

   utterance.voice = getBestGermanVoice();
   setPlayAudio(true);
   window.speechSynthesis.speak(utterance);

   utterance.onstart = () => setPlayAudio(true);
   utterance.onend = () => setPlayAudio(false);
   utterance.onerror = () => setPlayAudio(false);
}
